import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { LcaShareConvertResponse, LcaShareLinkResponse, ShareAuthCheckData, ShareLinkResponse } from '../../types';
import type { ShareIdApi } from '../share-id-api';

@injectable()
export class ShareIdApiImpl extends PsHttpService implements ShareIdApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getShareIdForGuest(inputData: ShareAuthCheckData) {
        return this.post<PatSnapCommonResponseData<ShareLinkResponse>>({
            url: '/share/create',
            data: inputData,
        }).then((res) => {
            return res.data as ShareLinkResponse;
        });
    }

    getShareId(inputData: ShareAuthCheckData) {
        return this.post<PatSnapCommonResponseData<ShareLinkResponse>>({
            url: '/secure-share/create',
            data: inputData,
        }).then((res) => {
            return res.data as ShareLinkResponse;
        });
    }

    getPDAShareId(data: Parameters<ShareIdApi['getPDAShareId']>[0]) {
        return this.post({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0/file/share`,
            data,
        }).then((res) => {
            return res;
        });
    }

    getLcaShareId(data: Parameters<ShareIdApi['getLcaShareId']>[0]) {
        return this.post<PatSnapCommonResponseData<LcaShareLinkResponse>>({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-lca-agent-api/share/create`,
            data,
        }).then((res) => {
            return res.data as LcaShareLinkResponse;
        });
    }

    convertLcaShare(jobId: string) {
        return this.post<PatSnapCommonResponseData<LcaShareConvertResponse>>({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-lca-agent-api/share/jobs/${jobId}/convert`,
            data: {},
        }).then((res) => {
            return res.data as LcaShareConvertResponse;
        });
    }

    sendPDAShareByEmail(data: Parameters<ShareIdApi['sendPDAShareByEmail']>[0]) {
        return this.post({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0/file/share/send_email`,
            data,
        }).then((res) => {
            return res;
        });
    }
}
